// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607300436/js/" + chunkId + "." + {"44":"3c4d2e04","225":"bb2ada26","481":"b2055a72","486":"f1d4511b","770":"c3a8a624"}[chunkId] + ".0.9510774558906082.chunk.js";
};